import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UsuarioService } from '../shared/service/usuario/usuario.service';
import { SegurancaService } from '../shared/service/seguranca/seguranca.service';
import { LoginService } from '../shared/service/login/login.service';
import { Recuperacao } from '../shared';
import { UtilService } from '../shared/service/util/util.service';

@Component({
    selector: 'app-confirma-redefinicao-pin',
    templateUrl: './confirma-redefinicao-pin.component.html',
    styleUrls: ['./confirma-redefinicao-pin.component.css']
})
export class ConfirmaRedefinicaoPinComponent implements OnInit {

    public codigoAutenticacao: string;
    private idUsuario: number;

    public novoPIN: string;
    public repetePIN: string;
    public tokenOTP: string;
    public regex : string;
    public descricaoRegex : string;
    public redefinido: boolean = false;
    public novoCodigo: string;

    constructor(
        private route: ActivatedRoute,
        private usuarioService : UsuarioService,
        private utilService: UtilService,
        private segurancaService : SegurancaService,
        private loginService : LoginService
    ) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.codigoAutenticacao = params["codigoAutenticacao"];
            // Assumindo token válido, idUsuario é a segunda parte entre os pontos
            this.idUsuario = +this.codigoAutenticacao.split('.')[1];
        });

        this.obterPoliticaSenhaPadrao();
    }

    redefinePIN() {
        if (this.novoPIN != this.repetePIN) {
            this.utilService.showError("PINs diferentes")
            return;
        }

        this.usuarioService.redefinirPIN(this.novoPIN, this.tokenOTP, this.codigoAutenticacao)
            .subscribe(res => {
                this.redefinido = true;
                this.novoCodigo = res.codigoChave;
                this.utilService.showSuccess('Redefinição de conta realizado com sucesso');
            },
            err => {
                this.utilService.showError(err.message);
            });
    }

    obterPoliticaSenhaPadrao() {
        this.segurancaService.obterPoliticaSenha().subscribe(
              res => {
                  this.regex = res.regex;
                  this.descricaoRegex = res.descricao;
              },
              err => {

                  if(err.status === 401 || err.status === 403){
                    this.loginService.logout();
                  }
                  this.utilService.showError(err.message);
              }
        );

      }

    enviarPorEmail() {
        let recuperacao: Recuperacao = new Recuperacao();
        recuperacao.codigoChave = this.novoCodigo;

        this.usuarioService.enviarEmailCodigoChave(this.idUsuario, recuperacao).subscribe(
            () => {
                this.utilService.showSuccess('E-mail enviado com sucesso!');
            },
            (err) => {
                this.utilService.showError(err.message);
            }
        );
    } 
}